<template>
  <v-content :style="{ background }">
    <v-toolbar
      flat
      fixed
      :class="{'top-toolbar': !mini, 'top-toolbar-expanded': mini}"
      style="border-bottom-style: solid; border-width:1px; border-color: #BDBDBD;"
    >
      <v-toolbar-side-icon @click="setMini"></v-toolbar-side-icon>
      <v-flex xs3>
        <v-toolbar-title class="body-2 font-weight-regular">
          <v-breadcrumbs :items="breadcrumb" class="ml-0 pl-0 font-weight-regular">
            <template v-slot:item="props">
              <a
                class="pa-0"
                style="text-decoration: none"
                :href="props.item.href"
                :class="[props.item.disabled && 'disabled']"
              >{{ props.item.text }}</a>
            </template>
          </v-breadcrumbs>
        </v-toolbar-title>
        <div></div>
      </v-flex>

      <v-flex></v-flex>
      <InactivityWarning></InactivityWarning>

      <v-flex xs3 text-xs-right align-center mb-0 mr-0 diplay-1>
        <div class="headline font-weight-medium" style="color: #337AB7;">{{client}}</div>
      </v-flex>

      <slot name="toolbar" />
    </v-toolbar>

    <v-container fluid class="pa-0 ma-0">
      <v-navigation-drawer
        style="background: #273747; height: 100vh;"
        :mini-variant="mini"
        v-model="drawer"
        hide-overlay
        fixed
        dark
        stateless
      >
        <v-layout column justify-space-between fill-height>
          <v-card flat class="transparent">
            <v-toolbar flat class="transparent pt-3">
              <v-list class="pa-0">
                <v-list-tile style="height:70px">
                  <!-- TODO: APP LOGO -->
                  <img src="~@/assets/img/smallLogo.jpg" alt style="width:45px" @click="setMini" />
                  <v-list-tile-content style="font-size:24pt" class="ml-3 pt-1">
                    <v-list-tile-title style="height:40px">
                      {{
                      appName
                      }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title class="ml-1" style="height:25px">
                      {{
                      appVersion
                      }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-btn icon @click.stop="setMini">
                      <v-icon>fa-chevron-left</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-toolbar>
            <v-list class="mt-1 transparent py-0 mb-0">
              <nav-link
                v-for="item in topItems"
                :item="item"
                :key="item.title"
                :page="page"
                :nav-collapsed="mini"
              />
            </v-list>
            <v-list class="transparent py-0 my-0" v-if="!role.includes('AR')">
              <nav-link
                v-for="item in topMiddleItems"
                :item="item"
                :key="item.title"
                :page="page"
                :nav-collapsed="mini"
              />
            </v-list>
            <v-list class="transparent py-0 my-0" v-if="role.includes('AR')">
              <v-list-group
                :value="subGroupOpen"
                :class="[{'miniDisplay':mini},{'miniDisplay': !role.includes('AR')}]"
                @click="setSubMenu"
              >
                <template v-slot:activator>
                  <nav-link
                    v-for="item in topMiddleItems"
                    :item="item"
                    :key="item.title"
                    :page="page"
                    :nav-collapsed="mini"
                    :parentPage="parentPage"
                  />
                </template>
                <nav-link
                  v-for="item in subItems"
                  :item="item"
                  :key="item.title"
                  :page="page"
                  :nav-collapsed="mini"
                />
              </v-list-group>
            </v-list>
            <v-list class="transparent py-0 my-0">
              <nav-link
                v-for="item in topBottomItems"
                :item="item"
                :key="item.title"
                :page="page"
                :nav-collapsed="mini"
              />
            </v-list>
            <v-list class="transparent py-0 my-0" v-if="hasDashboards==true">
              <v-list-group
                :value="subGroupOpenDashboard"
                :class="[{'miniDisplay':mini}]"
                @click="setSubMenuDashboard"
              >
                <template v-slot:activator>
                  <nav-link
                    v-for="item in topBottomMiddleItems"
                    :item="item"
                    :key="item.title"
                    :page="page"
                    :nav-collapsed="mini"
                    :parentPage="parentPage"
                  />
                </template>
                <nav-link
                  v-for="item in subItemsDashboard"
                  :item="item"
                  :key="item.title"
                  :page="page"
                  :nav-collapsed="mini"
                />
              </v-list-group>
            </v-list>
            <v-list class="transparent py-0 my-0">
              <nav-link
                v-for="item in topBottomBottomItems"
                :item="item"
                :key="item.title"
                :page="page"
                :nav-collapsed="mini"
              />
            </v-list>
          </v-card>

          <v-card class="transparent">
            <v-list class="mt-1 transparent">
              <!-- <v-divider></v-divider> -->
              <nav-link
                v-for="item in bottomItems"
                :item="item"
                :key="item.title"
                :page="page"
                :nav-collapsed="mini"
                :disabled="disabled"
              />
            </v-list>
          </v-card>
        </v-layout>
      </v-navigation-drawer>
      <div class="pb-0" :class="{'right-column': !mini, 'right-column-expanded': mini}">
        <slot />
      </div>
    </v-container>
  </v-content>
</template>

<script>
import NavLink from "../components/NavLink";
import { App } from "../config.js";
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import auth from "@/store/auth";
import * as helper from "../helpers/global";
import InactivityWarning from "../components/InactivityWarning.vue";
import moment from "moment";

export default {
  name: "DefaultLayout",
  props: {
    page: {
      type: String,
      default: ""
    },
    breadcrumb: {
      type: Array
    },
    test: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: "#FFFFFF"
    },
    parentPage: {
      type: String,
      default: ""
    }
  },
  components: { NavLink, InactivityWarning },
  data() {
    return {
      drawer: true,
      appName: App.name,
      appVersion: App.version,
      cruds: [
        ["Create", "fa-add"],
        ["Read", "fa-drive"],
        ["Update", "fa-update"],
        ["Delete", "fa-delete"]
      ],
      topItems: [
        {
          title: "Search",
          pages: ["Search"],
          icon: "fa-search",
          link: "/search"
        },
        // {
        //   title: "Users",
        //   pages: ["Users"],
        //   icon: "fa-user",
        //   link: "/users"
        // },
        {
          title: "Accounts",
          pages: ["Accounts"],
          icon: "fa-address-card",
          link: "/accounts/all"
        },
        {
          title: "Services",
          pages: ["Services"],
          icon: "fa-phone-square",
          link: "/services/all"
        },
        {
          title: "Charges",
          pages: ["Charges"],
          icon: "fa-money-check-alt",
          link: "/charges/all"
        }
      ],
      topMiddleItems: [
        {
          title: "Receivables",
          pages: ["Receivables"],
          icon: "fa-inbox",
          link: "/receivables/all",
          parentApp: true
        }
      ],
      topBottomItems: [
        {
          title: "Reports",
          pages: ["Reports"],
          icon: "fa-file-contract",
          link: "/reports"
        }
      ],

      topBottomBottomItems: [
        {
          title: "Tickets",
          pages: ["Tickets"],
          icon: "fa-ticket-alt",
          link: "/tickets/all"
        },
        {
          title: "Log",
          pages: ["Log"],
          icon: "fa-list-alt",
          link: "/log/account/all/all/all"
        }
      ],
      subItems: [],
      topBottomMiddleItems: [
        {
          title: "Dashboards",
          pages: ["Dashboards"],
          icon: "fa-chart-line",
          link: "/dashboards"
        }
      ],
      subItemsDashboard: [
        {
          title: "My Dashboards",
          pages: ["MyDashboards"],
          icon: "",
          link: "/my-dashboards",
          subapp: true
        }
      ],

      bottomItems: [
        {
          title: "User",
          subtitle: "",
          pages: [""],
          icon: "fa-user",
          disabled: true
        },
        {
          title: "Admin",
          pages: ["Admin Panel"],
          icon: "fa-wrench",
          link: "/admin",
          is_admin: this.is_admin
        },
        {
          title: "Logout",
          pages: [],
          icon: "fa-sign-out-alt",
          action: this.logout
        }
      ],

      // mini: true,
      right: null,
      role_id: {},
      is_admin: {},
      roles: [],
      selectedRole: "",
      user: null,
      role_name: null,
      disabled: false,
      role: null,
      subGroupOpen: true,
      subGroupOpenDashboard: true,
      client: null,
      passwordExpires: null,
      hasDashboards: null
    };
  },

  watch: {},
  computed: {
    ...mapGetters({
      // messages: 'messages',
      // role_id: "role_id",
      // is_admin: "is_admin",
    }),
    mini() {
      var mini = this.$store.state.auth.mini;

      return mini;
    }

    // ...mapState('auth', ['role_id', 'is_admin'])
  },

  mounted() {},

  created() {
    this.initializeUser();
  },

  methods: {
    initializeUser() {
      if (this.mini == true) {
        this.subGroupOpen = false;
        this.subGroupOpenDashboard = false;
      } else {
        this.subGroupOpen = this.$store.state.auth.sub_menu;
        this.subGroupOpenDashboard = this.$store.state.auth.sub_menu_dashboard;
      }
      this.role = helper.getRole();

      this.client = this.$store.state.auth.client;
      if (this.client == null) {
        this.$store.dispatch("auth/setClient").then(() => {
          this.client = this.$store.state.auth.client;
        });
      }

      //checks if user hasDashboards
      this.hasDashboards = this.$store.state.auth.has_dashboards;
      // if (this.hasDashboards == null) {
      this.$store.dispatch("auth/setHasDashboards").then(() => {
        this.hasDashboards = this.$store.state.auth.has_dashboards;
      });
      // }

      if (this.role.includes("AR")) {
        this.subItems.splice(0, 0, {
          title: "Active Batches",
          pages: ["Active Batches"],
          icon: "",
          link: "/active-batches",
          subapp: true
        });

        this.subItems.splice(1, 0, {
          title: "Posting History",
          pages: ["Posting History"],
          icon: "",
          link: "/posting-history",
          subapp: true
        });
      }

      this.user = this.$store.state.auth.user;

      var user = this.user;
      if (this.user) {
        this.bottomItems[0].title = user.split("@")[0];
        this.bottomItems[0].disabled = false;
        this.bottomItems[0].pages = ["My Account"];
        this.bottomItems[0].link = "/my-account";
      }
    },
    dummy() {
      this.mini = true;
    },
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push("/login");
      });
    },
    async setSubMenu() {
      var subMenu = this.subGroupOpen;
      subMenu = !subMenu;
      this.$store.dispatch("auth/setSubMenu", { subMenu }).then(async token => {
        this.subGroupOpen = subMenu;
      });
    },
    async setSubMenuDashboard() {
      var subMenu = this.subGroupOpenDashboard;
      subMenu = !subMenu;
      this.$store
        .dispatch("auth/setSubMenuDashboard", { subMenu })
        .then(async token => {
          this.subGroupOpenDashboard = subMenu;
        });
    },
    async setMini() {
      var mini = this.mini;
      mini = await !mini;

      this.$store.dispatch("auth/setNavMini", { mini }).then(async token => {
        // this.mini = await mini;
      });
      mini == true
        ? (this.subGroupOpen = false)((this.subGroupOpenDashboard = false))
        : (this.subGroupOpen = this.$store.state.auth.sub_menu)(
            (this.subGroupOpenDashboard = this.$store.state.auth.sub_menu_dashboard)
          );
    }
  }
};
</script>

<style lang="scss">
#backdrop {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: black;
  opacity: 0.3;
  z-index: 3;
}
.right-column-expanded {
  // margin-left: 15vw;
  margin-left: 80px;
  margin-top: 64px;
  padding-bottom: 10px;
  width: calc(100% - 80px) !important;
}
.right-column {
  margin-left: 15vw;
  width: calc(100% - 15vw) !important;
  // margin-left: 4vw;
  margin-top: 64px;
  padding-bottom: 10px;
}
.top-toolbar-expanded {
  background: #f9f9f9 !important;
  color: black !important;
  left: 80px !important;
  width: calc(100% - 80px) !important;
}
.top-toolbar {
  background: #f9f9f9 !important;
  color: black !important;
  left: 15vw !important;
  width: calc(100% - 15vw) !important;
}

aside.v-navigation-drawer.v-navigation-drawer--fixed.v-navigation-drawer--open.theme--dark {
  width: 15vw !important;
  min-width: 80px !important;
}
aside.v-navigation-drawer.v-navigation-drawer--fixed.v-navigation-drawer--mini-variant.v-navigation-drawer--open.theme--dark {
  width: 80px !important;
}

.v-toolbar___boarder {
  border-bottom: black !important;
  width: 10px !important;
}

.plant-select {
  width: 80%;
}

.plant-select item {
  text-align: center;
}

.disabled {
  color: grey;
  pointer-events: none;
}

.v-breadcrumbs li:nth-child(2n) {
  padding: 0 8px;
}

.container {
  max-width: 100%;
}

.small-table table.v-table thead tr {
  height: 35px;
}

.v-input.small-select {
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  font-size: 14px;
  text-align: left;
}
.miniDisplay div.v-list__group__header__append-icon {
  display: none;
}
div.v-list__group__header div.v-list__group__header__append-icon i.v-icon {
  font-size: 20px !important;
}
</style>

